import React, { forwardRef } from 'react';

import Button from '@mui/material/Button';
import { Alert, AlertColor } from '@mui/material';

import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { BiCheckCircle } from 'react-icons/bi';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { AlertActions } from '../../alertDispatcher';

const CATEGORY_COLOR_MAP = {
  success: '#43a047',
  error: '#cc0000',
  warning: '#ff8c00',
  info: '#4f86f7',
};

interface AlertMessageProps {
  actions?: AlertActions;
  category: AlertColor;
  confirmMessage?: string;
  confirmNum?: number;
  denyMessage?: string;
  disposeAlert?: (message: string) => void;
  id: number;
  message: string;
  needsConfirm: boolean;
  onConfirm: (message: string, confirm: boolean, confirmNum: number) => void;
  showAll: boolean;
}

const AlertMessage = forwardRef<HTMLDivElement, AlertMessageProps>((props, ref) => {
  return (
    <Alert
      ref={ref}
      elevation={6}
      variant="filled"
      severity={props.category}
      style={{
        fontSize: 'medium',
        width: 'max-content',
        maxWidth: 'calc(100vw - 60px)',
        color: 'white',
        backgroundColor: CATEGORY_COLOR_MAP[props.category],
      }}
      iconMapping={{
        success: <BiCheckCircle />,
        info: <AiOutlineInfoCircle />,
      }}
      action={
        !props.needsConfirm ? (
          <React.Fragment>
            {props.actions &&
              Object.keys(props.actions).map((action) => (
                <Button
                  key={action}
                  onClick={async () => {
                    props.disposeAlert && props.disposeAlert(props.message);
                    await props.actions?.[action]();
                  }}
                  style={{ color: 'white', textTransform: 'none' }}
                >
                  {action}
                </Button>
              ))}
            <IconButton
              size={'small'}
              onClick={() => props.disposeAlert && props.disposeAlert(props.message)}
              disabled={props.showAll}
            >
              <CloseIcon style={{ color: 'white' }} />
            </IconButton>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button
              onClick={() => props.onConfirm(props.message, true, props.confirmNum ?? 0)}
              data-testid={`message-${props.id}-confirm`}
              style={{ textAlign: 'center', color: 'white' }}
              disabled={props.showAll}
            >
              {props.confirmMessage ? props.confirmMessage : 'yes'}
            </Button>
            <Button
              onClick={() => props.onConfirm(props.message, false, props.confirmNum ?? 0)}
              data-testid={`message-${props.id}-deny`}
              style={{ textAlign: 'center', color: 'white' }}
              disabled={props.showAll}
            >
              {props.denyMessage ? props.denyMessage : 'no'}
            </Button>
          </React.Fragment>
        )
      }
    >
      {props.message}
    </Alert>
  );
});

export default AlertMessage;
